import React from 'react';
import { Route } from 'react-router-dom';


const Factory = ( modules, metadata ) => {

  return modules.domain.map( ( item ) => {

    const Pages = require( '../../../pages/modules' ).default;
    
    const Page = Pages.Data[ item.section ];

    return metadata[ item.slug ].map( ( model ) => {
      return (
        <React.Fragment key={model.slug}>

          <Route path={model.slug} element={<Page.List model={model} />} />
          
          <Route path={`${model.slug}/new`} element={<Page.Input model={model} />} />
          <Route path={`${model.slug}/:${item.handle}`} element={<Page.Output model={model} />} />
          <Route path={`${model.slug}/:${item.handle}/edit`} element={<Page.Input model={model} />} />

        </React.Fragment>
      );
    });
  });
};


export default Factory;